import { createFileRoute } from '@tanstack/react-router';

import { ProtectedRoute } from '@/components';
import PixidParamDematDashboard from '@/pages/PixidParamDematDashboard';

export const Route = createFileRoute('/pixid/param-demat')({
  component: () => (
    <ProtectedRoute>
      <PixidParamDematDashboard />
    </ProtectedRoute>
  ),
});
